import { render } from "./RegistCode.vue?vue&type=template&id=18eb4692&scoped=true"
import script from "./RegistCode.vue?vue&type=script&lang=js"
export * from "./RegistCode.vue?vue&type=script&lang=js"

import "./RegistCode.vue?vue&type=style&index=0&id=18eb4692&lang=scss&scoped=true"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18eb4692"]])

export default __exports__